import { useState, useEffect } from "react";

import axios from "axios";
import { Picture } from "./model/picture";

const GetPicture = (id: string): Picture => {
  const [picture, setPicture] = useState<Picture>({
    key: "",
    created_at: "",
    emotion: "",
    image_url: "",
  });

  const fetchPicture = async () => {
    const response = await axios.get(
      "https://webhook.otera05.xyz/webhook/" + id
    );
    const data = response.data;
    setPicture(data);
  };

  useEffect(() => {
    fetchPicture();
    // eslint-disable-next-line
  }, []);

  return picture;
};

export default GetPicture;
